/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
// Компоненты пользовательского интерфейса
import '../../styles/UippsMain.css';
import FilterForUipps from './FilterForUipps';
import TableForUipps from './TableForUipps';
import MultiMarkerMap from '../Maps/MultiMarkerMap';
import HeaderForObject from '../CustomElements/HeaderForObject';
import translations from '../../content/PagesContent/DevicePages/devicePageTranslations.json';
// Кастомные хуки
import useTranslations from '../../customHook/useTranslations';
import useInfiniteScroll from '../../customHook/useInfiniteScroll';
import { useFilterControl } from '../../customHook/useFilterControl';
// Действия Redux
import { emitGetCoordsStart, emitGetCoordsStop, listenUippsCoords } from '../../redux/actions/uipps.action';
import { clearUipps, initUippsFromServer } from '../../redux/actions/uipps.action';

function UippsMain() {
  // получение словаря для статических данных в зависимости от выбранного языка
  const t = useTranslations(translations);

  const [isViewMap, setIsViewMap] = useState(false);
  const [isViewList, setIsViewList] = useState(true);
  // состояние для строки поиска
  const [filterInput, setFilterInput] = useState('');

  // Начальное состояние для стейта фильтрации передаем пропсами
  const initialFormData = {
    id: '',
    roadId: '',
    directorateId: '',
    departmentId: '',
    trainTypeId: '',
    trainNumberId: '',
    responsible: '',
    online: '',
  };
  const [formData, setFormData] = useState(initialFormData);

  // хук для сброса фильтров и флага для отображения кнопки сброса
  const { resetFilters, showBtnReset } = useFilterControl(initialFormData, formData, setFormData, '', setFilterInput);

  // хук для запроса данных с учетом параметров поиска фильтрации и сортировки, и контроля скрола
  const { bottomBoundaryRef, handleSearch, mapSearchActive } = useInfiniteScroll(
    formData, // Данные фильтров
    filterInput, // Строка поиска
    setFilterInput, // Функция для изменения строки поиска
    initUippsFromServer, // Функция для инициализации данных
    'uipps', // Redux-селектор
    resetFilters, // Сброс фильтров
    clearUipps, // Очистка стейта
    isViewMap // Флаг для остановки запросов
  );

  return (
    <div className="uipps">
      <FilterForUipps
        setIsViewList={setIsViewList}
        setIsViewMap={setIsViewMap}
        isViewList={isViewList}
        isViewMap={isViewMap}
        initialFormData={initialFormData}
        formData={formData}
        setFormData={setFormData}
        showBtnReset={showBtnReset}
        resetFilters={resetFilters}
        t={t}
      />
      <div className="uipps_content">
        <HeaderForObject
          searchInput={filterInput}
          onFilterChange={(e) => {
            setFilterInput(e?.target?.value);
          }}
          onFilterSubmit={handleSearch}
        />
        {isViewList && <TableForUipps formData={formData} bottomBoundaryRef={bottomBoundaryRef} t={t} />}
        {isViewMap && (
          <MultiMarkerMap
            emitStartFunction={emitGetCoordsStart}
            listenMarkersFunction={listenUippsCoords}
            listenStopFunction={emitGetCoordsStop}
            formData={formData}
            filterInput={filterInput}
            setSearchInput={setFilterInput}
            t={t}
            mapSearchActive={mapSearchActive}
          />
        )}
      </div>
    </div>
  );
}

export default UippsMain;
